import { Button } from "@livingmap/hippo";

import styles from "./PageTitle.module.scss";

interface Props {
  dataQA: string;
  heading: string;
  subheading?: string;
  customButton?: {
    text: string;
    onClick: () => void;
  };
}

const PageTitle: React.FC<Props> = ({
  dataQA,
  heading,
  subheading,
  customButton,
}) => {
  return (
    <div data-qa={dataQA} className={styles.container}>
      <div>
        <h2 className={styles.heading}>{heading}</h2>
        {subheading && <h4 className={styles.subheading}>{subheading}</h4>}
      </div>
      {customButton && (
        <Button
          dataQA="heading-button"
          type="location"
          style="filled"
          text={customButton.text}
          size="small"
          className={styles.button}
          onClick={customButton.onClick}
        />
      )}
    </div>
  );
};

export default PageTitle;
